// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1ANUc","description":"PatientConsentPreview_description__2Wfnr"};